// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csCxU7M5teCNNl {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  scroll-margin: 80px;
}
.csCxU7M5teCNNl[hidden] {
  display: none;
}
.csCxU7M5teCNNl.T8gIajhK_pGFpP {
  opacity: 0.4;
}
.csCxU7M5teCNNl .PPk42xVXm4ipq3 {
  border-radius: var(--ds-border-radius-200, 8px);
}
.csCxU7M5teCNNl .PPk42xVXm4ipq3.rV0WxNoYIm5J3u {
  box-shadow: 0 0 0 2px var(--ds-link, #0c66e4);
}
`, ""]);
// Exports
export var listCard = `csCxU7M5teCNNl`;
export var isDragging = `T8gIajhK_pGFpP`;
export var cardWrapper = `PPk42xVXm4ipq3`;
export var selected = `rV0WxNoYIm5J3u`;
export default ___CSS_LOADER_EXPORT___;
